import "core-js";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";

import faIR from "antd/lib/locale-provider/fa_IR";
import enUS from "antd/lib/locale-provider/en_US";

import Router from "./router";
import store from "./scripts/store";

// import "leaflet/dist/leaflet.css";
import "./styles/globals.less";

const root = ReactDOM.createRoot(document.getElementById("root"));
const direction = process.env.REACT_APP_IS_RTL ? "rtl" : "ltr";

document.documentElement.dir = direction;

root.render(
	<ConfigProvider
		direction={direction}
		locale={process.env.REACT_APP_IS_RTL ? faIR : enUS}
	>
		<Provider store={store}>
			<Router />
		</Provider>
	</ConfigProvider>
);
